import { Controller } from "@hotwired/stimulus"

// Toolbar AI sulla selezione: appare sopra il testo selezionato dentro un
// [data-selection-scope]; invia la selezione (testo + occorrenza) all'endpoint
// suggestions della sezione e lascia che il Turbo Stream renda il blocco diff.
const PRESETS = {
  riscrivi: "Riscrivi questo frammento migliorandolo",
  espandi: "Espandi questo frammento con più dettagli",
  accorcia: "Accorcia questo frammento mantenendo il significato",
  tecnico: "Rendi questo frammento più tecnico e preciso"
}

export default class extends Controller {
  static targets = ["toolbar", "custom"]

  connect() {
    this._onSelection = () => this.evaluateSelection()
    document.addEventListener("selectionchange", this._onSelection)
  }

  disconnect() {
    document.removeEventListener("selectionchange", this._onSelection)
  }

  evaluateSelection() {
    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => {
      const selection = window.getSelection()
      const text = selection?.toString()?.trim()
      if (!text || text.length < 3 || selection.rangeCount === 0) return this.hide()

      const range = selection.getRangeAt(0)
      const scope = range.commonAncestorContainer.parentElement?.closest("[data-selection-scope]")
      if (!scope) return this.hide()

      this.currentScope = scope
      this.currentText = text
      this.currentOccurrence = this.occurrenceBefore(scope, range, text)
      this.show(range.getBoundingClientRect())
    }, 150)
  }

  occurrenceBefore(scope, range, text) {
    const pre = range.cloneRange()
    pre.selectNodeContents(scope)
    pre.setEnd(range.startContainer, range.startOffset)
    const before = pre.toString()
    let count = 0
    let index = before.indexOf(text)
    while (index !== -1) {
      count += 1
      index = before.indexOf(text, index + 1)
    }
    return count
  }

  show(rect) {
    const toolbar = this.toolbarTarget
    toolbar.classList.remove("hidden")
    const top = rect.top - toolbar.offsetHeight - 8
    toolbar.style.top = `${Math.max(top, 8)}px`
    toolbar.style.left = `${Math.max(rect.left, 8)}px`
  }

  hide() {
    this.toolbarTarget.classList.add("hidden")
  }

  act(event) {
    this.submit(PRESETS[event.currentTarget.dataset.preset])
  }

  actCustom(event) {
    event.preventDefault()
    const instruction = this.customTarget.value.trim()
    if (instruction) this.submit(instruction)
  }

  async submit(instruction) {
    if (!this.currentScope || !this.currentText) return
    const url = this.currentScope.dataset.suggestionsUrl
    const token = document.querySelector("meta[name='csrf-token']")?.content

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({
        suggestion: {
          kind: "selection_edit",
          original_text: this.currentText,
          occurrence: this.currentOccurrence,
          instruction: instruction
        }
      })
    })

    if (response.ok) {
      window.Turbo.renderStreamMessage(await response.text())
    }
    this.customTarget.value = ""
    this.hide()
    window.getSelection()?.removeAllRanges()
  }
}
